var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import logger from 'app/helpers/logger';
import store from 'app/configureStore';
import { downloadCredentialsFailed, downloadCredentialsSuccess } from 'app/actions/sandboxItemActions';
import apis from '../apis/index';
import { FETCH_SANDBOX, FETCH_SANDBOX_SUCCESS, FETCH_SANDBOX_FAILED, CREATE_SANDBOX, CREATE_SANDBOX_SUCCESS, CREATE_SANDBOX_FAILED, POLL_SANDBOX, POLL_SANDBOX_SUCCESS, POLL_SANDBOX_FAILED, GET_USE_CASES, GET_USE_CASES_FAILED, GET_USE_CASES_SUCCESS, } from '../reducers/constants';
import globalConstants from '../constants/global-constants';
var intialPollingTime = 2000;
var pollingTimeIncrement = 3000;
// ===== GET USE CASES =====
var getUseCases = function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
    var params, additionalUc, _a, error, useCases;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                params = {};
                additionalUc = window.localStorage && localStorage.getItem('additionalUc');
                if (additionalUc)
                    params.additionalUc = encodeURI(additionalUc);
                return [4 /*yield*/, apis.sandbox.getUseCases(params)];
            case 1:
                _a = _b.sent(), error = _a[0], useCases = _a[1];
                dispatch({
                    type: error ? GET_USE_CASES_FAILED : GET_USE_CASES_SUCCESS,
                    useCases: useCases,
                    error: error,
                });
                return [2 /*return*/];
        }
    });
}); };
export var beginGetUseCases = function () { return function (dispatch) {
    dispatch({
        type: GET_USE_CASES,
    });
    getUseCases(dispatch);
}; };
// ===== FETCH SANDBOX =====
var fetchSandbox = function (accessToken, dispatch) { return __awaiter(void 0, void 0, void 0, function () {
    var _a, error, sandbox;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0: return [4 /*yield*/, apis.sandbox.getUserRunningInstance(accessToken)];
            case 1:
                _a = _b.sent(), error = _a[0], sandbox = _a[1];
                dispatch({
                    type: error ? FETCH_SANDBOX_FAILED : FETCH_SANDBOX_SUCCESS,
                    sandbox: sandbox,
                    error: error,
                });
                return [2 /*return*/];
        }
    });
}); };
export var beginFetchSandbox = function (accessToken) { return function (dispatch) {
    dispatch({
        type: FETCH_SANDBOX,
    });
    fetchSandbox(accessToken, dispatch);
}; };
// ===== CREATE SANDBOX =====
var createSandbox = function (params, cb) { return __awaiter(void 0, void 0, void 0, function () {
    var _a, error, sandbox;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                if (!globalConstants.testing.create) return [3 /*break*/, 1];
                setTimeout(function () {
                    cb(false, globalConstants.testing.sampleSandboxPending);
                }, 2000);
                return [3 /*break*/, 3];
            case 1:
                logger.info('Creating sandbox...', params);
                return [4 /*yield*/, apis.sandbox.createInstance(params)];
            case 2:
                _a = _b.sent(), error = _a[0], sandbox = _a[1];
                cb(error, sandbox);
                _b.label = 3;
            case 3: return [2 /*return*/];
        }
    });
}); };
export var beginCreateSandbox = function (params) { return function (dispatch) {
    dispatch({
        type: CREATE_SANDBOX,
        usecase: params.usecase,
    });
    createSandbox(params, function (error, sandbox) {
        dispatch({
            type: error ? CREATE_SANDBOX_FAILED : CREATE_SANDBOX_SUCCESS,
            sandbox: sandbox,
            error: error,
        });
    });
}; };
// ===== POLL SANDBOX =====
var pollSandbox = function (accessToken, sandboxHashKey, timer, cb) { return __awaiter(void 0, void 0, void 0, function () {
    var err, _a, error, sandbox, targetSandbox, ip, password, port, content, blob, link;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0: return [4 /*yield*/, apis.sandbox.getSandboxByHash(accessToken, sandboxHashKey)];
            case 1:
                err = (_b.sent())[0];
                if (err && timer < 80000) {
                    return [2 /*return*/, setTimeout(function () { return pollSandbox(accessToken, sandboxHashKey, pollingTimeIncrement, cb); }, timer)];
                }
                return [4 /*yield*/, apis.sandbox.getUserRunningInstance(accessToken)];
            case 2:
                _a = _b.sent(), error = _a[0], sandbox = _a[1];
                if (error) {
                    cb(error, null);
                    return [2 /*return*/, null];
                }
                if (Array.isArray(sandbox)) {
                    targetSandbox = sandbox.find(function (item) { return item.sandboxHashKey === sandboxHashKey; });
                    if (targetSandbox) {
                        ip = targetSandbox.ip, password = targetSandbox.password, port = targetSandbox.port;
                        content = "NEO4J_URI=bolt://".concat(ip, "\nNEO4J_USERNAME=neo4j\nNEO4J_PASSWORD=").concat(password, "\nNEO4J_DATABASE=neo4j\n");
                        blob = new Blob([content], { type: 'text/plain' });
                        link = document.createElement('a');
                        // @ts-ignore
                        store.dispatch(downloadCredentialsSuccess());
                        link.download = "".concat(targetSandbox.usecase_long_name, " Sandbox Credentials.txt");
                        link.href = window.URL.createObjectURL(blob);
                        document.body.appendChild(link);
                        link.click();
                        document.body.removeChild(link);
                    }
                    else {
                        // @ts-ignore
                        store.dispatch(downloadCredentialsFailed());
                    }
                }
                cb(null, sandbox);
                return [2 /*return*/, null];
        }
    });
}); };
export var beginPollingSandbox = function (accessToken, sandboxHashKey) { return function (dispatch) {
    dispatch({
        type: POLL_SANDBOX,
    });
    setTimeout(function () {
        pollSandbox(accessToken, sandboxHashKey, intialPollingTime, function (error, sandbox) {
            dispatch({
                type: error ? POLL_SANDBOX_FAILED : POLL_SANDBOX_SUCCESS,
                sandbox: sandbox,
                error: error,
            });
        });
    }, 5000);
}; };
